import * as yup from 'yup';
import { isValidYupSchema, yupUtils } from '../../utils/yup/utils';
import { Author } from '../types/author';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { getInitials } from './utils';

export const MinimalAuthorSchema = yup.object().shape({
  name: yupUtils.stringRequired('Name is a required field'),
  bio: yupUtils.stringOptionalNullable,
  description: yupUtils.stringOptionalNullable.max(100, 'Description must be less than 100 characters'),
  learnFromMentor: yupUtils.stringOptionalNullable,
  releaseDate: yupUtils.dateOptionalNullable,
  isActive: yupUtils.booleanOptionalNullable,
  isFeatured: yupUtils.booleanOptionalNullable,
  isNew: yupUtils.booleanOptionalNullable,
  categoryId: yupUtils.stringOptionalNullable,
});

export const AuthorSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  name: yupUtils.stringRequired(),
  imagePath: yupUtils.stringOptionalNullable,
  customThumbnailImagePath: yupUtils.stringOptionalNullable,
  description: yupUtils.stringOptionalNullable,
  learnFromMentor: yupUtils.stringOptionalNullable,
  releaseDate: yupUtils.dateOptionalNullable,
  isActive: yupUtils.booleanOptionalNullable,
  isFeatured: yupUtils.booleanOptionalNullable,
  isNew: yupUtils.booleanOptionalNullable,
  categoryId: yupUtils.stringOptionalNullable,
});

const processAuthor = async (author: any): Promise<Author> => {
  return {
    ...author,
    initials: getInitials({ name: author?.name }),
  };
};

export const parseAuthor = async (object: any): Promise<Author | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(AuthorSchema, object)) {
      return processAuthor(object as Author);
    }
    return getProjectErrorForCode(ProjectErrors.invalidAuthor);
  } catch (error) {
    console.log(`[AUTHORS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseAuthors = async (items: any): Promise<Author[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[AUTHORS] Error: No array found.');
    return [];
  }

  const data: Author[] = [];
  for (const item of items) {
    const o = await parseAuthor(item);
    if (o && !isProjectError(o)) {
      data.push(o as Author);
    }
  }

  return data;
};
